import { IconButton } from '@chakra-ui/react';
import { ReactComponent as SidebarIcon } from '../../../logos/sidebarIcon.svg';

const SidebarButton = ({ onClose, p }) => {
  return (
    <IconButton
      icon={<SidebarIcon />}
      aria-label='Close sidebar'
      borderRadius='3px'
      border='1px solid'
      borderColor='#59595B'
      bg='#FFFFFF'
      p={p ? p : null}
      onClick={onClose}
    />
  );
};

export default SidebarButton;
